'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _translate = require('../../language/translate');

var _CheckboxComponent = require('../../components/input/CheckboxComponent');

var _CheckboxComponent2 = _interopRequireDefault(_CheckboxComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prefer-stateless-function */

/**
 * Renders the purchase confirmation message.
 * @extends {Component}
 */
var PurchaseMessageComponent = function (_React$Component) {
  _inherits(PurchaseMessageComponent, _React$Component);

  function PurchaseMessageComponent() {
    _classCallCheck(this, PurchaseMessageComponent);

    return _possibleConstructorReturn(this, (PurchaseMessageComponent.__proto__ || Object.getPrototypeOf(PurchaseMessageComponent)).apply(this, arguments));
  }

  _createClass(PurchaseMessageComponent, [{
    key: 'isRecurringPaymentEnabled',
    value: function isRecurringPaymentEnabled() {
      return !this.props.showTermsCheckbox && this.props.fields.payment.payment_option.value === 'monthly';
    }
  }, {
    key: 'render',
    value: function render() {
      var termsType = this.props.showTermsCheckbox ? (0, _translate.t)('Pay Now') : (0, _translate.t)('Buy Now');
      return _react2.default.createElement(
        'div',
        { className: 'purchase-message-box' },
        _react2.default.createElement(
          _reactBootstrap.Col,
          { xs: 1 },
          _react2.default.createElement(_CheckboxComponent2.default, {
            inputId: 'terms',
            htmlLabel: '',
            field: this.props.fields.terms
          })
        ),
        this.isRecurringPaymentEnabled() ? _react2.default.createElement(
          _reactBootstrap.Col,
          { xs: 11 },
          (0, _translate.t)('By clicking Buy Now, I agree to the following amounts charged to the credit card entered above, and authorize 10 recurring monthly premium charges. I confirm that all of the information entered in this form is complete and accurate to the best of my knowledge. I understand that I must read the policy wording for a full description of my coverage.')
        ) : _react2.default.createElement(
          _reactBootstrap.Col,
          { xs: 11 },
          (0, _translate.t)('By clicking %(type)s I agree to have %(price)s charged to the credit card entered above. I confirm that all of the information entered in this form is complete and accurate to the best of my knowledge. I understand that I must read the policy wording for a full description of my coverage.', { price: this.props.price, type: termsType })
        )
      );
    }
  }]);

  return PurchaseMessageComponent;
}(_react2.default.Component);

PurchaseMessageComponent.propTypes = {
  fields: _react2.default.PropTypes.object,
  price: _react2.default.PropTypes.string,
  showTermsCheckbox: _react2.default.PropTypes.bool
};
exports.default = PurchaseMessageComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/common/PurchaseMessageComponent.jsx
// module id = 806
// module chunks = 0